import CategoryQuiz from './CategoryQuiz/CategoryQuiz.jsx'
import ScoredQuiz from './ScoredQuiz/ScoredQuiz.jsx'

export { ScoredQuiz, CategoryQuiz }
